import React from "react";
import { useTranslation } from "react-i18next";
import { PARAMETER_OPTIONS } from "../../constants";
import Select from "./select";

const PARAM_KEY = {
  Sets: "sets",
  Rounds: "rounds",
  Reps: "reps",
  "RPE/AMRAP": "rpeAmrap",
  Time: "time",
  Distance: "distance",
  Load: "load",
  Rest: "rest",
  Velocity: "velocity",
  "Free-Form": "freeForm",
  RPE: "rpe",
  None: "none",
};

const {
  SETS,
  ROUNDS,
  REPS,
  RPE,
  RPEAMRAP,
  TIME,
  DISTANCE,
  LOAD,
  REST,
  VELOCITY,
  FREEFORM,
  NONE,
} = PARAMETER_OPTIONS;

function SelectParameters({
  value,
  index,
  handleChange,
  form,
  intensityMeasure,
  overlay = false,
}) {
  const { t } = useTranslation("common");
  return (
    <>
      <Select
        name={`parameter${index}`}
        className="select-input"
        options={[
          NONE,
          SETS,
          ROUNDS,
          REPS,
          RPEAMRAP,
          TIME,
          DISTANCE,
          LOAD,
          REST,
          VELOCITY,
          FREEFORM,
        ].map((parameter) => ({
          text: [RPE, RPEAMRAP].includes(parameter)
            ? intensityMeasure
            : t(`common:parameterOptions.${PARAM_KEY[parameter]}`),
          value: parameter,
        }))}
        value={value}
        onChange={(val) =>
          handleChange({ target: { name: `parameter${index}`, value: val } })
        }
        disabled={false}
        overlay={overlay}
      />
    </>
  );
}

export default SelectParameters;
